const limitStringLength = (s, maxLength) => {
  if (s.length <= maxLength) return s;
  return s.slice(0, maxLength) + "...";
};

export default limitStringLength;
